import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalEscalationsRoute: InvariantJiraRoute = {
	name: 'eoc-global-escalations',
	path: '/jira/settings/products/ops/escalation-policies',
	exact: true,
};
